import { render } from "./WalletBody.vue?vue&type=template&id=b6e94900&scoped=true"
import script from "./WalletBody.vue?vue&type=script&lang=js"
export * from "./WalletBody.vue?vue&type=script&lang=js"

import "./WalletBody.vue?vue&type=style&index=0&id=b6e94900&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e94900"]])

export default __exports__